import { LineChart, CartesianGrid, XAxis, YAxis, Line, ResponsiveContainer, Tooltip, Legend } from 'recharts'
import './UsageStats.scoped.scss'
import { format } from 'date-fns';

const ICONS = {
    'rocket-blue': <SvgIconsRocketBlue />,
    'money': <SvgIconsMoney />,
    'trend-up': <SvgIconsTrendUp />
}

function Stat({ large = false, vertical = false, icon, label, number, prefix = null }) {
    const formattedNumber = number ? `${prefix ? prefix : ''}${Number(number).toLocaleString()}` : '-'
    return <div className={`usage-stat ${vertical ? 'vertical' : ''}`}>
        {icon && <div className={`icon ${large ? '' : 'smaller'}`}>{ICONS[icon]}</div>}
        <div className='content'>
            <div className="number">
                <p className={`${large ? 'larger' : 'smaller'}`}>{formattedNumber}</p>
            </div>
            <p className={`label ${large ? 'larger' : ''}`}>
                {label}
            </p>
        </div>
    </div>
}

function StatSection({ title, entries }) {
    return <div className="stat-section">
        <p className='stat-header'>{title}</p>
        {entries.map((entry, i) => <Stat key={i} icon={'trend-up'} label={entry.label} vertical={false} number={entry.number} />)}
    </div>
}

export default function UsageStats({ }) {
    const [stats, setStats] = useState(null)
    const [graphData, setGraphData] = useState(null)
    const showGraph = graphData && graphData.length > 0

    const featureDonations = useSel(s => window.ENV.FEATURES['donations'])
    const featureEmail = useSel(s => window.ENV.FEATURES['email'])
    const featurePhone = useSel(s => window.ENV.FEATURES['phone'])
    const featureSms = useSel(s => window.ENV.FEATURES['sms'])
    const featureWhatsapp = useSel(s => window.ENV.FEATURES['whatsapp'])

    const callStats = () => {
        return (featurePhone && stats) ? <StatSection title='Calls' entries={[
            { label: 'Calls Made', number: stats['calls'] },
            { label: 'Answered', number: stats['calls_answered'] },
            { label: 'Conversions', number: stats['calls_conversions'] }
        ]} /> : <></>
    }
    const smsStats = () => {
        return (featureSms && stats) ? <StatSection title='Text Messages' entries={[
            { label: 'Texts Sent', number: stats['texts'] },
            { label: 'Clicks', number: stats['texts_clicked'] },
            { label: 'Replies', number: stats['texts_replied'] }
        ]} /> : <></>
    }
    const emailStats = () => {
        return (featureEmail && stats) ? <StatSection title='Emails' entries={[
            { label: 'Emails Sent', number: stats['emails'] },
            { label: 'Opens', number: stats['emails_opened'] },
            { label: 'Clicks', number: stats['emails_clicked'] }
        ]} /> : <></>
    }
    const whatsappStats = () => {
        return (featureWhatsapp && stats) ? <StatSection title='WhatsApp' entries={[
            { label: 'Whatsapps Sent', number: stats['whatsapps'] },
            { label: 'Opens', number: stats['whatsapps_read'] },
            { label: 'Clicks', number: stats['whatsapps_clicked'] }
        ]} /> : <></>
    }
    const donationsTotal = (stats && featureDonations) ? (stats['donations_total'] ? (parseFloat(stats['donations_total']) / 100).toFixed(2) : 0) : null

    useEffect(() => {
        axios.get('/api/reporting/stats').then(({ data }) => {
            setStats(data)
            setGraphData(data.contacts_graph)
        })
    }, [])

    return <div className="row">
        <div className="column half">
            <div className="box full-height">
                <div className="row full-height">
                    {stats &&
                        <div className="column third border-right">
                            <Stat icon={'rocket-blue'} label={'Contacts Made'} large={true} vertical={true} number={stats['contacts']} />
                            {featureDonations && <Stat icon={'money'} label={'Amount Raised'} large={true} vertical={true} number={donationsTotal} prefix={'£'} />}
                        </div>
                    }

                    {stats && <div className="column two-thirds stat-container">
                        {callStats()}
                        {smsStats()}
                        {emailStats()}
                        {whatsappStats()}
                    </div>}
                </div>
            </div>
        </div>

        <div className="column half">
            <div className="box">
                <p className='stat-header'>Contacts this month</p>
                {showGraph && <ResponsiveContainer height={220}>
                    <LineChart width={500} height={300} data={graphData}>
                        <XAxis axisLine={false} tickLine={false} dataKey="date" tickFormatter={time => format(new Date(time), 'dd/MM')} />
                        <YAxis axisLine={false} tickLine={false} allowDecimals={false} tickFormatter={(v) => v.toLocaleString()} />
                        <CartesianGrid vertical={false} stroke="#eee" strokeDasharray="5 5" />
                        <Tooltip />
                        <Legend verticalAlign="top" height={36} />
                        {featureSms ? <Line type="monotone" dataKey="text_message_count" name="Text Messages" stroke="#E69900" strokeWidth={3} /> : <></>}
                        {featureEmail ? <Line type="monotone" dataKey="email_count" name="Emails" stroke="#00b9d2" strokeWidth={3} /> : <></>}
                        {featureWhatsapp ? <Line type="monotone" dataKey="whatsapp_count" name="Whatsapps" stroke="#00D586" strokeWidth={3} /> : <></>}
                    </LineChart>
                </ResponsiveContainer>}
                {!showGraph && graphData && <p className='no-margin-top no-margin-bottom'>
                    You've not made any contacts yet! Once you do, we'll show you more stats.
                </p>}
            </div>
        </div>
    </div>
}
